"use client";

import {MessageCircle, PhoneCall} from "lucide-react";
import {useLocale, useTranslations} from "next-intl";

const WA_NUMBER = "919793463801";

export function FloatingActions() {
  const locale = useLocale();
  const t = useTranslations("floating");

  const prefill = locale === "hi" ? t("whatsappPrefillHi") : t("whatsappPrefillEn");
  const waHref = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(prefill)}`;

  return (
    <>
      {/* Desktop / tablet: callback left */}
      <a
        href="tel:+919793463801"
        className="fixed bottom-6 left-4 z-40 hidden min-h-12 items-center gap-2 rounded-full bg-[var(--clinic-accent-fill)] px-5 text-sm font-semibold text-white shadow-[0_12px_30px_rgba(91,40,31,0.25)] transition hover:-translate-y-0.5 hover:bg-[var(--clinic-accent-fill-hover)] md:inline-flex md:left-6"
      >
        <PhoneCall className="h-4 w-4" aria-hidden />
        {t("callback")}
      </a>

      {/* Desktop / tablet: WhatsApp FAB with pulse ring */}
      <a
        href={waHref}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t("whatsapp")}
        className="fixed bottom-6 right-4 z-40 hidden h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl ring-2 ring-white transition hover:-translate-y-0.5 hover:scale-[1.04] dark:ring-[var(--clinic-bg)] md:flex md:right-6"
      >
        <span
          className="absolute inset-0 rounded-full bg-[#25D366] opacity-20"
          aria-hidden
        />
        <MessageCircle className="relative z-10 h-7 w-7" aria-hidden />
      </a>
    </>
  );
}
